import Login from "./Login";

function LoginPage () {

    return(
        <Login></Login>
    )
}

export default LoginPage;